<script setup>
const openTikTok = () => {
  window.open("https://www.tiktok.com/@soallofthatmeanothing?is_from_webapp=1&sender_device=pc", "_blank")
}

openTikTok()
</script>